/**
 * Dashboard Notifications Module
 * Handles notification interactions on the dashboard
 */

(function($) {
  'use strict';

  const DashboardNotifications = {

    /**
     * Initialize the notifications module
     */
    init: function() {
      this.currentIndex = 0;
      this.totalNotifications = $('.notifications-single-view').data('total') || 0;
      this.bindEvents();
      this.setupActionButtons();
    },

    /**
     * Ensure every unread notification has a "Remove" action button
     * placed to the left of any other action buttons in its footer.
     */
    setupActionButtons: function() {
      $('.notification-item.unread').each(function() {
        const $item = $(this);
        if ($item.find('.btn-dismiss').length) return;

        let $actions = $item.find('.notification-actions');
        if (!$actions.length) {
          $actions = $('<div class="notification-actions"></div>').appendTo($item.find('.notification-content'));
        }

        $('<button type="button" class="btn-dismiss button small hollow">Remove</button>').prependTo($actions);
      });
    },

    /**
     * Bind event handlers
     */
    bindEvents: function() {
      // Delegate click events for dismiss buttons
      $(document).on('click', '.notification-item .btn-dismiss', this.handleDismiss.bind(this));

      // Navigation buttons
      $(document).on('click', '.notification-navigation .nav-btn.prev', this.navigatePrev.bind(this));
      $(document).on('click', '.notification-navigation .nav-btn.next', this.navigateNext.bind(this));

      // Keyboard navigation
      $(document).on('keydown', this.handleKeyboardNavigation.bind(this));
    },

    /**
     * Navigate to previous notification
     */
    navigatePrev: function() {
      if (this.currentIndex > 0) {
        this.navigateToIndex(this.currentIndex - 1);
      }
    },

    /**
     * Navigate to next notification
     */
    navigateNext: function() {
      if (this.currentIndex < this.totalNotifications - 1) {
        this.navigateToIndex(this.currentIndex + 1);
      }
    },

    /**
     * Navigate to specific index
     */
    navigateToIndex: function(index) {
      if (index < 0 || index >= this.totalNotifications) return;

      // Hide current notification
      $('.notification-item.active').removeClass('active').fadeOut(200, () => {
        // Show target notification
        const $target = $('.notification-item[data-index="' + index + '"]');
        if ($target.length) {
          $target.fadeIn(200).addClass('active');
        } else if (this.totalNotifications > 0) {
          // If target doesn't exist, navigate to the closest valid index
          const validIndex = Math.min(index, this.totalNotifications - 1);
          $('.notification-item[data-index="' + validIndex + '"]').fadeIn(200).addClass('active');
          this.currentIndex = validIndex;
        }
      });

      this.currentIndex = index;
      this.updateNavigationState();
    },

    /**
     * Update navigation controls state
     */
    updateNavigationState: function() {
      // Update counter
      $('.notification-counter .current').text(this.currentIndex + 1);

      // Update button states
      $('.nav-btn.prev').prop('disabled', this.currentIndex === 0);
      $('.nav-btn.next').prop('disabled', this.currentIndex >= this.totalNotifications - 1);
    },

    /**
     * Handle keyboard navigation
     */
    handleKeyboardNavigation: function(e) {
      // Only handle if notifications are visible
      if (!$('.notifications-single-view').is(':visible')) return;

      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          this.navigatePrev();
          break;
        case 'ArrowRight':
          e.preventDefault();
          this.navigateNext();
          break;
      }
    },

    /**
     * Handle notification dismissal
     */
    handleDismiss: function(e) {
      e.preventDefault();
      e.stopPropagation();

      const $button = $(e.currentTarget);
      const $notification = $button.closest('.notification-item');
      const notificationId = $notification.data('notification-id');

      if (!notificationId) {
        console.error('No notification ID found');
        return;
      }

      // Disable the button to prevent multiple clicks
      $button.prop('disabled', true);

      // Add loading state
      $button.html('<i class="fas fa-spinner fa-spin"></i>');

      // Make the AJAX request
      $.ajax({
        url: '/notifications/' + notificationId + '/dismiss',
        method: 'POST',
        dataType: 'json',
        success: (response) => {
          if (response.success) {
            this.removeNotification($notification);
          } else {
            this.handleError($button, response.error || 'Failed to dismiss notification');
          }
        },
        error: (xhr, status, error) => {
          this.handleError($button, 'Network error: ' + error);
        },
      });
    },

    /**
     * Remove notification from DOM with animation
     */
    removeNotification: function($notification) {
      const isSingleView = $('.notifications-single-view').length > 0;

      if (isSingleView) {
        // Handle single view
        const currentIndex = parseInt($notification.data('index'));

        $notification.fadeOut(300, () => {
          $notification.remove();
          this.totalNotifications--;

          if (this.totalNotifications === 0) {
            // Show empty state and hide navigation
            this.checkEmptyState();
            $('.card-subheader.notification-navigation').fadeOut(300);
          } else if (this.totalNotifications === 1) {
            // Only one left — nav only makes sense with more than one.
            $('.card-subheader.notification-navigation').fadeOut(300);

            $('.notification-item').each(function(index) {
              $(this).attr('data-index', index);
            });
            this.currentIndex = 0;
            this.navigateToIndex(0);
            this.updateNotificationBadge();
          } else {
            // Update indices for remaining notifications
            $('.notification-item').each(function(index) {
              $(this).attr('data-index', index);
            });

            // Navigate to appropriate notification
            if (currentIndex >= this.totalNotifications) {
              this.currentIndex = this.totalNotifications - 1;
            }
            this.navigateToIndex(this.currentIndex);

            // Update counter
            $('.notification-counter .total').text(this.totalNotifications);
            this.updateNavigationState();
          }

          this.updateNotificationBadge();
        });
      } else {
        // Handle list view (original code)
        const $dateGroup = $notification.closest('.notification-date-group');

        $notification.fadeOut(300, function() {
          $(this).slideUp(200, function() {
            $(this).remove();

            if ($dateGroup.find('.notification-item').length === 0) {
              $dateGroup.fadeOut(200, function() {
                $(this).remove();
                DashboardNotifications.checkEmptyState();
              });
            }

            DashboardNotifications.updateNotificationBadge();
          });
        });
      }
    },

    /**
     * Handle dismissal errors
     */
    handleError: function($button, errorMessage) {
      console.error('Failed to dismiss notification:', errorMessage);

      // Restore the button
      $button.prop('disabled', false);
      $button.html('Remove');

      // Show error feedback (you could enhance this with a toast notification)
      $button.addClass('error');
      setTimeout(() => {
        $button.removeClass('error');
      }, 2000);
    },

    /**
     * Update the notification badge count
     */
    updateNotificationBadge: function() {
      const unreadCount = $('.notification-item.unread').length;
      const $badge = $('.dashboard-card h5 .badge');

      if (unreadCount > 0) {
        if ($badge.length) {
          $badge.text(unreadCount);
        } else {
          $('.dashboard-card h5').append(' <span class="badge badge-primary">' + unreadCount + '</span>');
        }
      } else {
        $badge.fadeOut(200, function() {
          $(this).remove();
        });
      }
    },

    /**
     * Check if we need to show the empty state
     */
    checkEmptyState: function() {
      const $singleView = $('.notifications-single-view');
      const $notificationsList = $('.notifications-list');
      const $container = $singleView.length ? $singleView : $notificationsList;

      if ($container.find('.notification-item').length === 0) {
        // Show empty state
        const emptyStateHtml = `
                    <div class="empty-state text-center py-4" style="display: none;">
                        <i class="fas fa-bell-slash fa-3x text-muted mb-3"></i>
                        <p class="text-muted">No notifications at this time</p>
                    </div>
                `;

        $container.fadeOut(200, function() {
          $(this).replaceWith($(emptyStateHtml).fadeIn(300));
        });
      }
    },

    /**
     * Mark all notifications as read
     */
    markAllAsRead: function() {
      const $unreadNotifications = $('.notification-item.unread');
      let processed = 0;

      $unreadNotifications.each(function() {
        const $notification = $(this);
        const notificationId = $notification.data('notification-id');

        $.ajax({
          url: '/notifications/' + notificationId + '/dismiss',
          method: 'POST',
          dataType: 'json',
          success: function(response) {
            if (response.success) {
              $notification.removeClass('unread');
              $notification.find('.btn-dismiss').fadeOut(200, function() {
                $(this).remove();
              });
            }

            processed++;
            if (processed === $unreadNotifications.length) {
              DashboardNotifications.updateNotificationBadge();
            }
          },
        });
      });
    },
  };

  // Initialize when DOM is ready
  $(document).ready(function() {
    DashboardNotifications.init();
  });

  // Export for global access if needed
  window.DashboardNotifications = DashboardNotifications;

})(jQuery);